<template>
    <div class="">
        <label>
            <span>Target groups</span>
            <i v-if="info" class="fa fa-info-circle text-muted" data-toggle="tooltip" data-placement="right" :title="info"></i>

            <div v-if="loading" class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </label>
        <div class="tag-container">
            <tag v-for="(tag, index) in tags" :key="index" :tag="tag" @remove="onRemoveTag" />
            <a href class="text-decoration-none" :class="! Number(this.publicationId) ? 'text-muted disabled':''" @click="onOpen"><span v-if="tags.length == 0">Select target groups</span> <i class="fa fa-plus" aria-hidden="true"></i></a>

            <Modal title="Select targets" :show="showModal" @close="onClose">
                <checkbox-input name="target_groups"
                    label="Targets"
                    dimension="vertical"
                    for-else-message="No targets available"
                    :items="tagOptions"
                    :checked="selectedTags"
                    :error="phpError"
                    @changed="onChange"
                    ref="checkboxInputRef"></checkbox-input>

                <form @submit="onAdTag">
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="Target" ref="inputRef">
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="onAdTag">Add</button>
                        </div>
                    </div>

                    <div class="invalid-feedback d-block" v-if="error">
                        {{ error }}
                    </div>
                </form>

                <template v-slot:footer>
                    <button class="btn btn-primary" @click="onSubmit">Submit</button>
                    <button class="btn btn-link"  @click.prevent="onClose">Close</button>
                </template>
            </Modal>
        </div>
        <div class="text-info small" v-if="notification">
            {{ notification }}
        </div>
        <div class="invalid-feedback d-block" v-if="phpError">
            {{ phpError }}
        </div>
    </div>
</template>

<script>
import Modal from "../Modal";
import Tag from "./Tag.vue";
import { EventBus } from '../../event-bus.js';
import CheckboxInput from "../Inputs/CheckboxInput.vue";
import TextInput from "../Inputs/TextInput.vue";

export default {
    components: {
        Modal,
        Tag,
        CheckboxInput,
        TextInput,
    },
    props: {
        info: { type:String, default: '', required:false },
        savedTags: { type:Array, required:true},
        options: { type:Array, required:true},
        notification: { type:String, default:'', required:false},
        savedPublicationId: { type:Number, required:true },
        phpError: { type: String, default: '', required: false },
    },
    data() {
        return {
            tags: this.savedTags,
            selectedTags: this.savedTags.map(tag => tag.id),
            tagOptions: this.options,
            showModal: false,
            error: '',
            loading: false,
            publicationId: this.savedPublicationId,
        };
    },
    created() {
        EventBus.$on('publication-changed-targets', (name, value) => {
            this.publicationId = value;

            if(! Number(this.publicationId)) {
                this.tags = [];

                return;
            }

            this.loading = true;
            axios.get('/api/publications/' + value + '/targets').then(response => {
                this.tags = response.data.targets;
                this.loading = false;
            }).catch(() => {
                this.tags = [];
                this.loading = false;
            });
        });

        EventBus.$on('publication-added-targets', (name, value) => {
            this.publicationId = value;
            this.tags = [];
        });
    },
    beforeDestroy() {
        EventBus.$off('publication-changed-targets');
        EventBus.$off('publication-added-targets');
    },
    methods: {
        onRemoveTag(id) {
            this.tags = this.tags.filter(t => t.id !== id);
            this.selectedTags = this.selectedTags.filter(selectedId => selectedId !== id);
        },
        async onAdTag(event) {
            if(event) {
                event.preventDefault();
            }

            const newTag = this.$refs.inputRef.value.trim();
            this.error = '';

            if (newTag) {
                if(this.tagOptions.some(tag => tag.name.toLowerCase().replace(/\s+/g, '') === newTag.toLowerCase().replace(/\s+/g, ''))) {
                    this.error = 'The target group has already been taken.'

                    return;
                }

                let params = { name: newTag };

                await axios.post('/api/target-groups', params)
                    .then((response) => {
                        this.tagOptions.push({ id: response.data.target.id, name: response.data.target.name });
                        this.selectedTags.push(response.data.target.id);
                        this.$refs.inputRef.value = "";

                    }).catch(error => {
                        if (error.response && error.response.status == 422) {
                            this.error = error.response.data.errors.name[0];
                        }

                });
            }
        },
        async onSubmit(event) {
            event.preventDefault();
            await this.onAdTag();
            if(! this.error) {
                this.tags = this.tagOptions.filter(tag => this.selectedTags.includes(tag.id ));
                this.showModal = false;
            }
        },
        onChange(id) {
            if(this.selectedTags.includes(id)) {
                this.selectedTags = this.selectedTags.filter(tagId => tagId !== id);
            } else {
                this.selectedTags.push(id);
            }
        },
        onOpen(event) {
            event.preventDefault();
            if(Number(this.publicationId)) {
                this.showModal = true;
                this.selectedTags = this.tags.map(tag => tag.id);
            }
        },
        onClose() {
            this.showModal = false;
            this.error = '';
        },
    }
};
</script>

<style scoped lang="scss">
.tag-container {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    align-items: center;
}
.disabled {
    cursor: not-allowed;
}
</style>
